export const FILE_CONFIG = {
  BASE_URL: 'https://strapi.onixx.ru/'
} as const;
